import { postRequest } from "./postRequest";

const CallReview_API = process.env.REACT_APP_CALL_REVIEW

console.log("API URL:", CallReview_API);
export const postCallReview = (payload) => {

    
  return postRequest(CallReview_API, payload);
};
